// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"X6-z","categoryName":"Y6-z","categoryImage":"Z6-z","categoryContent":"_6-z","bottomAligned":"a7-z"};